module.exports = __webpack_public_path__ + "static/media/sel_11_254.46244199.mp4";